import { Box, Group, Text, Title } from '@mantine/core';
import React from 'react';

export const PageHeader = ({
    title,
    subtitle,
    action,
}: {
    title: string;
    subtitle?: string;
    action?: React.ReactNode;
}) => (
    <Group justify='space-between' align='flex-end' mb='lg' wrap='wrap'>
        <Box>
            <Title order={2}>{title}</Title>
            {subtitle && (
                <Text c='dimmed' size='sm' mt={4} maw={560}>
                    {subtitle}
                </Text>
            )}
        </Box>
        {action}
    </Group>
);
